"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.button = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var buttonVariationStyles = function buttonVariationStyles(theme) {
  return {
    transparent: (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: transparent;\n    border: 1px solid ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n  "])), theme.colorNeutral20, theme.colorButtonPrimaryLight),
    primary: (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border: none;\n    background-color: ", ";\n    font-weight: 500;\n    transition: box-shadow 0.3s;\n  "])), theme.colorButtonPrimaryLight)
  };
};

var buttonVariantionSizes = function buttonVariantionSizes(theme) {
  return {
    small: (0, _stylitas.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 6px 12px;\n    border-radius: 8px;\n    ", "\n  "])), _styleUtilities.typography.sm(theme)),
    medium: (0, _stylitas.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding: 12px 20px;\n    border-radius: 10px;\n    ", "\n  "])), _styleUtilities.typography.sm(theme)),
    large: (0, _stylitas.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    padding: 18px 20px;\n    border-radius: 16px;\n    ", "\n  "])), _styleUtilities.typography.md(theme))
  };
};

var buttonExtraStyles = function buttonExtraStyles() {
  return {
    hasOnlyIcon: (0, _stylitas.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    border-radius: 50%;\n    width: 64px;\n    height: 64px;\n    padding: 0px;\n  "])))
  };
};

var buttonVariationHoverStyles = function buttonVariationHoverStyles(_ref) {
  var theme = _ref.theme;
  return {
    transparent: (0, _stylitas.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-color: ", ";\n  "])), theme.colorButtonPrimaryLight, theme.colorButtonPrimaryLight),
    primary: (0, _stylitas.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    box-shadow: 0px 16px 8px -12px rgba(0, 0, 0, 0.12),\n      0px 16px 12px -8px rgba(0, 0, 0, 0.16);\n  "])))
  };
};

var button = function button(_ref2) {
  var theme = _ref2.theme,
      hasOnlyIcon = _ref2.hasOnlyIcon,
      variant = _ref2.variant,
      alignment = _ref2.alignment,
      size = _ref2.size;
  return (0, _stylitas.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    width: 100%;\n    text-decoration: none;\n    cursor: pointer;\n    position: relative;\n\n    display: flex;\n    align-items: center;\n\n    justify-content: ", ";\n    color: ", ";\n\n    ", "\n    ", "\n    ", "\n\n    &:hover {\n      ", "\n    }\n\n    &:active {\n      &::before {\n        position: absolute;\n        content: '';\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: ", ";\n        opacity: 0.05;\n      }\n    }\n\n  "])), alignment, theme.colorNeutral90, buttonVariantionSizes(theme)[size], buttonVariationStyles(theme)[variant], hasOnlyIcon && buttonExtraStyles().hasOnlyIcon, buttonVariationHoverStyles({
    theme: theme
  })[variant], theme.colorNeutral90);
};

exports.button = button;